import * as colors from "./colors";

import * as mq from "./media-queries";

export const globalStyles = {
  "*, *::after, *::before": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },
  body: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: "calc(16 * 100vw / 1440)",
    color: colors.white,
    [mq.small]: {
      fontSize: "calc(16 * 100vw / 360)",
    },
    [mq.medium]: {
      fontSize: "calc(16 * 100vw / 768)",
    },
  },
  button: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
  },
};
